import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IconExit } from "../../icons/icons";
import { getGameFromSlug } from "../../api/user";
import { toast } from "react-toastify";
import { BASE_URL } from "../../config/api";
import Default from "./Default.svg";

// The league's cover, as it appears on a phone: a full-width band above whatever
// screen you're on.
//
// It claims no height until the file has actually decoded. An <img> normally
// reserves its 16:9 box the moment it mounts, so a cover that's slow — or that
// 404s, which happens whenever a league's stored path doesn't resolve — opens a
// blank gap above the page title and then snaps shut. Better to take the space
// only once there's something to put in it.
const MobileCover = ({ src, alt }) => {
  const [state, setState] = useState("loading");

  if (state === "failed") return null;

  return (
    <img
      src={src}
      alt={alt}
      onLoad={() => setState("ready")}
      onError={() => setState("failed")}
      className={`rounded-2xl w-full object-cover aspect-video object-center ${
        state === "ready" ? "mb-3" : "hidden"
      }`}
    />
  );
};

const GameSideBar = (props) => {
  const navigate = useNavigate();
  const { activeMenu, slug } = props;
  const [viewMode, setViewMode] = useState(activeMenu);
  const isMobileView = document.body.clientWidth <= 768;
  const [game, setGame] = useState(null);
  const [loading, setLoading] = useState(false);


  const handleRouteClick = (route) => {
    return () => {
      setViewMode(route);
      navigate(`/${slug}/${route}`);
    };
  };



    const handleExitGame = () => {
      localStorage.removeItem("game_type");
      localStorage.removeItem("isAuthenticated");
    navigate("/contest/my-games", { state: { viewMode: "member" } });
  };

    useEffect(() => {

        const checkGameDates = (start_date, end_date) => {

            const endDate = new Date(end_date.replace(" ", "T")); // Parse game.end_date
            const startDate = new Date(start_date.replace(" ", "T")); // Parse game.start_date
            const today = new Date(); // Get today's date
            today.setHours(0, 0, 0, 0); // Set time to midnight to ignore time component

            if (today >= startDate && today <= endDate) {
                return true;
            } else {
                return false;
            }

        }

        const fetchGameId = async (slug) => {
            try {
                const response = await getGameFromSlug({ slug });
                const gameData = response?.data?.data;
                if (gameData) {
                    //if(checkGameDates(gameData.start_date, gameData.end_date)){
                        setGame(gameData);
                        setLoading(true);
                  //  }
                  //  else{
                      //  toast.error("League is not active");
                        // navigate("/contest/my-games");
                        // navigate("/contest/my-games", { state: { viewMode: "creator" } });
                  //  }
                } else {
                    // toast.error("League not found");
                    // navigate("/contest/my-games");
                    // navigate("/contest/my-games", { state: { viewMode: "member" } });
                }
            } catch (error) {
                console.error("Error fetching game ID:", error);
            }
        };

        fetchGameId(slug);

    }, [slug]);

  const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "svg", "webp"];
  const videoExtensions = ["mp4", "avi", "mov", "wmv", "flv", "mkv", "webm"];
  let fullImageUrl = null;
let extension = null;
let hasUploadedImage = false;

 if(game){
     const imagePath =
    game.game_image && game.game_image.length > 0
      ? game.game_image[0].image
      : null;

  const filename = imagePath ? imagePath.split("/").pop() : null;

  // Did the organiser actually upload something, or is this the grey placeholder?
  // On mobile that distinction matters: the placeholder is a full-width 16:9 band
  // of empty grey sitting above the page's own title, so it only earns its space
  // when there's a real cover to show.
  hasUploadedImage = !!filename;

   fullImageUrl = filename
    ? `${BASE_URL}/storage/upload/game/image/${filename}`
    : Default;


   extension = fullImageUrl.split(".").pop().toLowerCase();

 }



  return (
    <>

{loading && (
  isMobileView ? (
 <>
    {game && hasUploadedImage && imageExtensions.includes(extension) && (
      <MobileCover src={fullImageUrl} alt={game.title} />
    )}
    {game && hasUploadedImage && videoExtensions.includes(extension) && (
      <video
        autobuffer
        autoPlay
        playsInline={true}
        webkit-playsinline="true"
        x5-playsinline="true"
        x-webkit-airplay="deny"
        disablePictureInPicture={true}
        controlsList="nodownload"
        onContextMenu={(e) => e.preventDefault()}
        loop
        muted
        style={{ maxWidth: "100%", height: "auto" }}
        className="rounded-2xl mb-3 w-full object-cover aspect-video object-center"
      >
        <source
          src={fullImageUrl}
          type={`video/${extension === "mov" ? "mp4" : extension}`}
        />
        Your browser does not support the video tag.
      </video>
    )}
  </>
  ) : (
          <div className="sideBar_outer_main">
            <div className="sideBar_outer">
              <div className="grid mb-10 lg:pl-5 columns-1 gap-5 sticky top-5">
                {/* Toggle between Creator and Member */}
                <button
                  className={`text-left px-5 h-[52px] rounded-[5px] py-2 text-base border-none cursor-pointer block ${
                    viewMode === "feeds"
                      ? "bg-primaryColor text-white"
                      : "bg-[#F1F5F9]"
                  }`}
                  onClick={handleRouteClick("feeds")}
                >
                  Posts
                </button>
                <button
                  className={`text-left px-5 h-[52px] rounded-[5px] py-2 text-base border-none cursor-pointer block ${
                    viewMode === "buysell"
                      ? "bg-primaryColor text-white"
                      : "bg-[#F1F5F9]"
                  }`}
                  onClick={handleRouteClick("buysell")}
                >
                  Buy/Sell
                </button>
                <button
                  className={`text-left px-5 h-[52px] rounded-[5px] py-2 text-base border-none cursor-pointer block ${
                    viewMode === "charts"
                      ? "bg-primaryColor text-white"
                      : "bg-[#F1F5F9]"
                  }`}
                  onClick={handleRouteClick("charts")}
                >
                  Charts
                </button>
                <button
                  className={`text-left px-5 h-[52px] rounded-[5px] py-2 text-base border-none cursor-pointer block ${
                    viewMode === "portfolio"
                      ? "bg-primaryColor text-white"
                      : "bg-[#F1F5F9]"
                  }`}
                  onClick={handleRouteClick("portfolio")}
                >
                  Portfolio
                </button>
                <button
                  className={`text-left px-5 h-[52px] rounded-[5px] py-2  text-base border-none cursor-pointer block ${
                    viewMode === "leaderboard"
                      ? "bg-primaryColor text-white"
                      : "bg-[#F1F5F9]"
                  }`}
                  onClick={handleRouteClick("leaderboard")}
                >
                  Leaderboard
                </button>
              </div>
              <div className="pl-5 pb-2">
                <button className="px-6 h-10 rounded-[5px] py-2  text-sm border-none cursor-pointer flex gap-2.5 items-center bg-primaryColor text-white" onClick={handleExitGame}>
                  {IconExit} Exit League
                </button>
              </div>
            </div>
          </div>
  )
)}






       </>
  );
};

export default GameSideBar;
